import { AppColor, AppColorContainer } from "../AppColorContainer";

/** This is the color container dark mode implementation used by getAppColorContainer interface implementation for OneNote app */
export class DarkModeOneNoteAppColorContainer implements AppColorContainer {
  darkLabelColor: AppColor = { value : "#212121" };

  mediumLabelColor: AppColor = { value : "#EDEBE9" };

  lightLabelColor: AppColor = { value : "#D2D0CE" };

  timestampLabelColor: AppColor = { value: "#F3F2F1" };

  linkColor: AppColor = { value: "#82ABF1" };

  defaultBackgroundColor: AppColor = { value: "#292827" };

  lightBackgroundColor: AppColor = { value: "#3B3A39" };

  darkBackgroundColor: AppColor = { value: "#161514" };

  primaryWidgetColor: AppColor = { value: "#5B1382" };

  primaryWidgetColorOnHover: AppColor = { value: "#862EB5" };

  primaryWidgetLabelColor: AppColor = { value: "#ffffff" };

  secondaryWidgetColor: AppColor = { value: "#3B3A39" };

  secondaryWidgetColorOnHover: AppColor = { value: "#1D1C1B" };

  secondaryWidgetLabelColor: AppColor = { value: "#FFFFFF" };

  secondaryWidgetLabelColorOnHover: AppColor = { value: "#598FEC" };

  secondaryWidgetBorderColor: AppColor = { value:  "#797775" };

  blackColor: AppColor = { value: "#ffffff" };

  whiteColor: AppColor = { value: "#292827" };

  wordBlue: AppColor = { value: "#2e6ac5" };

  keyboardFocusColor: AppColor = { value: "#A3A09E" };

  lightBlue: AppColor = { value: "#0078d4" };

  tagBlue: AppColor = { value: "#2E6AC5" };

  bulletGray: AppColor = { value: "#4D4D4D" };

  progressBackground: AppColor = { value: "#545352" };

  popupBackground: AppColor = { value: "#B7D1FF" };

  transcribeIllustrationHeadsetInnerColor: AppColor = { value: "#FEFEFE" };

  transcribeIllustrationHeadsetOuterColor: AppColor = { value: "#DCDCDC" };

  transcribeIllustrationHeadsetWireColor: AppColor = { value: "#DC9FFD" };

  transcribeIllustrationCatLegsColor: AppColor = { value: "#F2D9FF" };

  transcribeIllustrationCatBodyGradientStartColor: AppColor = { value: "#D5A3F0" };

  transcribeIllustrationCatBodyGradientEndColor: AppColor = { value: "#F2D9FF" };

  transcribeIllustrationCatTailGradientStartColor: AppColor = { value: "#EBC6FF" };

  transcribeIllustrationCatTailGradientEndColor: AppColor = { value: "#F3DAFF" };

  micWidgetBorderColor: AppColor = { value: "#7719AA" };

  // TODO: change color as per one note
  charcoalColor: AppColor = { value: "#333333" };

  darkGrayColor: AppColor = {value: "#404040"};

  transcriptionIndicatorTextColor: AppColor  = {value: "#9E9E9E"};

  officeDesktopBackgroundColor: AppColor = {value: "#F0F0F0"};

  recordingIconRingsColor: AppColor = {value: "#4D4352"};

  listeningIconOuterColor: AppColor = {value: '#D1ABE6'};

  listeningIconMicColor: AppColor = {value: '#292929'};

  pauseIconOuterColor: AppColor = {value: '#000000'};

  pauseIconMicColor: AppColor = {value: '#D1ABE6'};

  oneDriveInfoTextColor: AppColor = {value: '#000000'};

  dropDownSelectionColor: AppColor = {value: '#626161'};

  dropDownHoverColor: AppColor = {value: '#979797'};

  private static instance: DarkModeOneNoteAppColorContainer | null = null;

  static GetInstance() {
    if (this.instance == null) this.instance = new DarkModeOneNoteAppColorContainer();

    return this.instance;
  }
}